export default __webpack_public_path__ + "static/services-bc67422a23204f819e61a52d3f233773.png";